import { defineMessage } from 'services/localization';

export const messages = {
    titleBefore: defineMessage('allfeatures_trial_for_name_expires_on_date'),
    desciptionBefore: defineMessage('want_to_keep_the_featur_hey_will_be_deactivated'),
    titleAfter: defineMessage('allfeatures_trial_for_n_anization_ended_on_date'),
    descriptionAfter: defineMessage('all_the_features_that_a__youre_ready_to_upgrade'),
    upgrade: defineMessage('upgrade_subscription'),
};
